import { render, staticRenderFns } from "./des-list.vue?vue&type=template&id=8a8c3f70&scoped=true&"
import script from "./des-list.vue?vue&type=script&lang=js&"
export * from "./des-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8c3f70",
  null
  
)

export default component.exports